export const fontFamilyData = [
    { "fontKey": "arial-bold", "name": "Arial Bold" },
    { "fontKey": "arial-black", "name": "Arial Bold Black" },
    { "fontKey": "balloon", "name": "Balloon" },
    { "fontKey": "benguiat", "name": "Benguiat Bold" },
    { "fontKey": "berkshire-swash", "name": "Berkshire Swash Regular" },
    { "fontKey": "the-blacklight", "name": "Blacklight" },
    { "fontKey": "boinklet", "name": "Boink" },
    { "fontKey": "brush-script", "name": "Brush Script" },
    { "fontKey": "carlisleregular", "name": "Carlisle Italic" },
    { "fontKey": "ldfcomicsans-bold", "name": "Comic Sans" },
    { "fontKey": "cookie", "name": "Cookie" },
    { "fontKey": "coopbl", "name": "Cooper Black" },
    { "fontKey": "dom-bold", "name": "Dom Bold" },
    { "fontKey": "expo-bold", "name": "Expo" },
    { "fontKey": "gill-sans-bold", "name": "Gill Sans Bold" },
    { "fontKey": "impact", "name": "Impact" },
    { "fontKey": "just-old-fashion", "name": "Just Old Fashion" },
    { "fontKey": "kabel-ultra", "name": "Kabell" },
    { "fontKey": "lucida-calligraphy-italic", "name": "Lucida Calligraphy" },
    { "fontKey": "rocky-horror", "name": "Rocky Horror" },
    { "fontKey": "times-new-roman", "name": "Times New Roman Bold" },
    { "fontKey": "trebuchet", "name": "Trebuchet" },
]